import { BrowserRouter } from "react-router-dom";
import { AppRoutes } from "./router";
import { I18nextProvider } from "react-i18next";
import i18n from "./i18n";
import { Suspense, useEffect, useState } from "react";
import { useLocation } from "react-router-dom";
import { ErrorBoundary } from "./components/ErrorBoundary";
import AdminPcOnlyScreen from "./layouts/AdminPcOnlyScreen";

function ScrollToTop() {
  const { pathname } = useLocation();

  useEffect(() => {
    window.scrollTo(0, 0);
  }, [pathname]);

  return null;
}

function App() {
  const [isPc, setIsPc] = useState(() => window.innerWidth >= 1024);

  useEffect(() => {
    const robots = document.querySelector<HTMLMetaElement>('meta[name="robots"]') ?? document.createElement('meta');
    robots.name = 'robots';
    robots.content = 'noindex, nofollow';
    if (!robots.parentNode) document.head.appendChild(robots);
    const media = window.matchMedia('(min-width: 1024px)');
    const update = () => setIsPc(media.matches);
    update();
    media.addEventListener('change', update);
    return () => media.removeEventListener('change', update);
  }, []);

  if (!isPc) return <AdminPcOnlyScreen />;

  return (
    <ErrorBoundary scope="app">
      <I18nextProvider i18n={i18n}>
        <BrowserRouter>
          <ScrollToTop />
          <Suspense fallback={null}>
            <AppRoutes />
          </Suspense>
        </BrowserRouter>
      </I18nextProvider>
    </ErrorBoundary>
  );
}

export default App;
